import React, { ReactNode, memo, useMemo, useState } from 'react';
import { Card, Button } from 'tea-component';
import Iconfont from '@gp/components/Iconfont';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import Loading from '@gp/components/Loading';
import TopIcon from '@gp/components/TopIcon';
import NoData from '@gp/components/NoData';
import LinkJump from '@gp/components/LinkJump';
import { queryJumpable } from '@gp/utils/common';
import { renderToString } from 'react-dom/server';
// import moment from 'moment';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import TextAreaMore from '@/pages/globalpedia/components/TextAreaMore';
import GeneralModal from '@/pages/globalpedia/components/GeneralModal';
import SvgIcon from '@/pages/home/components/SvgIcon';
import ExpandCollapseText from '@/pages/globalpedia/components/ExpandCollapse';
import NewsContent from './NewsContent';

const SIGN_BG_COLOR = ['#EDB600', '#84ACD6', '#BA8137'];
export type NewsItemType = {
  signBgColor: string;
  info: string;
  date: string;
  newsType: string;
  // 新闻标题
  titleCn: string;
  titleEn: string;
  // 日期
  postedOn: string;
  // 新闻主体
  news: string;
  // 点goto需要跳转的url
  url: string;
  [keyName: string]: string;
};

interface NewsPropsType {
  loading: boolean;
  data: any;
  studioId: string;
}

const DEFAULT_PROPS: NewsPropsType = {
  loading: false,
  data: null,
  studioId: '',
};
const shareIcon = (
  <SvgIcon
    type="other-share-icon"
    onClick={(e) => {
      e?.stopPropagation();
      e?.preventDefault();
    }}
  />
);
function News(props: NewsPropsType) {
  const { loading, data, studioId } = props;

  const infos: NewsItemType[] = useMemo(() => {
    let res: NewsItemType[] = [];
    const news = data?.companyNews;
    if (Array.isArray(news) && news?.length) {
      res = news
        ?.map(
          (
            t: {
              news: string;
              postedOnTime: string;
              newsType: string;
              [keyName: string]: string;
            },
            i: number,
          ) => {
            return {
              ...t,
              signBgColor: SIGN_BG_COLOR[i],
              info: t?.news,
              date: t?.postedOnTime,
              newsType: t?.newsType,
            };
          },
        )
        ?.slice(0, 3);
    }

    return res;
  }, [data]);
  const [visible, setVisible] = useState<boolean>(false);
  const [datatext, setDatatext] = useState<string | ReactNode>('');
  // 缓存当前点击打开弹窗的新闻
  const [currentNews, setCurrentNews] = useState<NewsItemType | null>(null);
  // 获取弹窗中新闻的主体
  const getContent = (item: NewsItemType) => {
    return <NewsContent {...item} />
  };
  return (
    <CardSlot
      className="dbg-details-overview-news"
      // className=""
      title="Recent News & Activity"
      isAction
      getDetails={(isJump: boolean, e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!queryJumpable(e)) return;
        if (!studioId) return;
        const url = `${window?.location?.origin}/v2/intelligence/topCharts/companies/gamesDetails/${studioId}/NewsActivity`;
        isJump && window.open(url, '_blank');
        return url;
      }}
    // operation={
    //   <LinkJump
    //     url={
    //       studioId
    //         ? `${window?.location?.origin}/v2/intelligence/topCharts/companies/gamesDetails/${studioId}/NewsActivity`
    //         : ''
    //     }
    //   >
    //     <Button
    //       type="link"
    //       className="gp-common-navigator-btn"
    //       onClick={(e) => {
    //         if (!queryJumpable(e)) return;
    //         if (!studioId) return;
    //         window.open(
    //           `${window?.location?.origin}/v2/intelligence/topCharts/companies/gamesDetails/${studioId}/NewsActivity`,
    //           '_blank',
    //         );
    //       }}
    //     >
    //       <span>View More</span>
    //       <Iconfont
    //         type="title-arrow"
    //         className="gp-common-navigator-btn-icon"
    //       />
    //     </Button>
    //   </LinkJump>
    // }
    >
      {loading && <Loading className="dbg-details-overview-news-state-action" loading />}
      {loading || (
        <div className="overview-news-content font14">
          {Array.isArray(infos) && infos?.length ? (
            infos?.map((t: NewsItemType, i: number) => {
              return (
                <div key={i} className="news-item" onClick={(e: any) => {
                  setCurrentNews(t);
                  setDatatext(getContent(t));
                  setVisible(true);
                }}>
                  {/* <TopIcon text={String(i + 1)} bgColor={t?.signBgColor} /> */}
                  <div className="news-item-info">
                    {/* <EllipsisTextBubble
                      className="gp-word-break-word"
                      ellipsisLineClamp={2}
                      text={t?.info || '-'}
                    /> */}
                    {/* <TextAreaMore
                        className="dbg-word-break-word"
                        type="ellipsis"
                        foldButtonText="More"
                        text={`EqualOcean - Daiwa：${t?.info}` || '-'}
                        onClick={() => {
                          setDatatext(`EqualOcean - Daiwa：${t?.info}` || '-');
                          setVisible(true);
                        }}
                      /> */}
                    <ExpandCollapseText
                      text={renderToString(<>
                        {t?.info || '-'}
                        <span className="overview-news-content-icon">{shareIcon}</span>
                      </>
                      )}
                      onClick={(e: any) => {}}
                      otherText={
                        <div className="overview-news-content-text">
                          <span className="overview-news-content-icon dbg-mr">{shareIcon}</span>
                          more
                        </div>
                      }
                    />

                    <div className="news-item-info-footer">
                      <span className="footer-sign">{t?.newsType || '-'}</span>
                      <label className="footer-halving"></label>
                      <span className="footer-date">
                        {/* {(moment(t?.date).isValid() && t?.date) ? moment(t?.date).format('MMM DDD,YYYY') : '-'} */}
                        {t?.date || '-'}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <NoData className="dbg-details-overview-news-state-action" />
          )}
        </div>
      )}
      {/* Show All弹窗 */}
      <GeneralModal
        className="gp-word-break-word"
        modalSize="m"
        visible={visible}
        title="Media News"
        content={datatext}
        isFooter={true}
        // 尾部按钮
        footerButtonGroup={['goto', 'cancel']}
        // 自定义尾部按钮的配置
        customFooterButtonGroup={{
          goto: {
            type: 'primary',
            text: 'Go to',
            ClickFn: () => {
              window.open(currentNews?.url);
              setVisible(false);
            }
          }
        }}
        onClose={() => {
          setVisible(false);
        }}
      />
    </CardSlot>
  );
}

News.defaultProps = DEFAULT_PROPS;

export default memo(News);
